/**
 * Alpine.js component for parameter button modal functionality
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('ParameterModal', ({ baseUrl, parameterName }) => ({
    isOpen: false,
    parameterValue: '',
    
    init() {
      // Component initialization
    },
    
    openModal() {
      this.isOpen = true;
      this.parameterValue = '';
      
      // Focus the input after the modal is shown
      this.$nextTick(() => {
        if (this.$refs.input) {
          this.$refs.input.focus();
        }
      });
    },
    
    closeModal() {
      this.isOpen = false;
      this.parameterValue = '';
    },
    
    submitValue() {
      const value = this.parameterValue.trim();
      
      if (value) {
        let finalUrl = baseUrl;
        if (finalUrl.includes('?')) {
          finalUrl += '&' + parameterName + '=' + encodeURIComponent(value);
        } else {
          finalUrl += '?' + parameterName + '=' + encodeURIComponent(value);
        }
        
        window.location.href = finalUrl;
      }
    }
  }));
}); 